module.exports = __webpack_public_path__ + "img/new13.e5c0ddf9.png";